import React, { Component } from 'react';
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
} from 'react-bootstrap';
import PatientsImage from './PatientsImage';
import { appConfig } from '../../../config';
import '../../Common/Common.css';
import ModalImage from 'react-modal-image';
import ReactPaginate from 'react-paginate';
var dateFormat = require('dateformat');
class PatientsViewModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientsImgModal: false,
      itempage: 0,
      itemsperPage: 5,
    };
    this.mouseOver = this.mouseOver.bind(this);
  }

  mouseOver = data => {
    this.setState({ patientsImgModal: true, ImageData: data });
  };

  closeImgModel = () => {
    this.setState({ patientsImgModal: false });
  };

  itemsPageClick = ev => {
    const selecteditemPage = ev.selected;
    this.props.itempageSelected({
      item: this.props.patientuserDtls,
      page: selecteditemPage + 1,
    });
    this.setState({ itempage: selecteditemPage });
  };

  resetitemPage = () => {
    //For resetting the itemdetail table to page 1 in pagination
    this.setState({
      ...this.state,
      itempage: 0,
    });
  };

  getName = value => {
    return value && value.name ? value.name : '';
  };

  render() {
    const { itempage, itemsperPage } = this.state;

    const itemcount =
      this.props.patientsprscrptnlsCount && this.props.patientsprscrptnlsCount;
    let itemPageCount = Math.ceil(itemcount / itemsperPage);

    const data =
      this.props.patientuserDtls && this.props.patientuserDtls.item
        ? this.props.patientuserDtls.item
        : null;

    const datas = this.props.patientsmainDtls || null;


    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            className="chemistmodeldiv"
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: '35px', backgroundColor: '#f0f3f5' }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: '20px' }}>Profile Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ fontSize: '15px' }}>
              <Row>
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div className="chemistdetails">
                    <p>
                      <span className="cmn_Cap"> Name : </span>{' '}
                      {data !== null && data.name}
                      <br />
                      <span className="cmn_Cap"> Mobile : </span>{' '}
                      {data !== null && data.mobileNo}
                      <br />
                      <span className="cmn_Cap"> Email : </span>{' '}
                      {datas !== null && datas.email}
                      <br />
                      <span className="cmn_Cap"> Address : </span>{' '}
                      {datas !== null && datas.addr}
                    </p>
                  </div>
                </Col>

                <Col xs={12} sm={12} md={4} lg={4} />
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div>
                    <p>
                      <span className="cmn_Cap"> City : </span>{' '}
                      {datas !== null && datas.city},{' '}
                      {datas !== null && this.getName(datas.state)}
                      ,{' '}
                      {datas !== null && this.getName(datas.district)}
                      <br />
                      <span className="cmn_Cap"> Landmark : </span>{' '}
                      {datas !== null && datas.landmark}
                      <br />
                      <span className="cmn_Cap"> Pincode : </span>{' '}
                      {datas !== null && datas.zip}
                      <br />
                      <span className="cmn_Cap"> Created Date : </span>{' '}
                      {data !== null && data.createdAt
                        ? dateFormat(data.createdAt, 'dd-mmm-yyyy')
                        : null}
                    </p>
                  </div>
                </Col>
              </Row>

              <hr />
              <Row>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <h4>Prescription Info</h4>
                </Col>

                <Col xs={12} sm={12} md={3} lg={3} />
                <Col xs={12} sm={12} md={3} lg={3} />

                <Col xs={12} sm={12} md={3} lg={3}>
                  <div>
                    <span className="cmnPageCount">
                      {' '}{/* {itemcount !== undefined ? itemcount : 0} */}
                      {itemcount !== undefined ? itemcount : 0}
                    </span>
                    <span className="cmnResutText">Results</span>
                  </div>
                </Col>
              </Row>

              <Table responsive bordered className="cmnMainTable">
                <thead>
                  <tr>
                    <th> Patient Name </th>
                    <th>Doctor Name </th>
                    <th>Prescription Notes </th>
                    <th>Prescription Image </th>
                    <th>Prescription Date </th>
                    <th>Status </th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.patientsprscrptnls &&
                    this.props.patientsprscrptnls.map((item, i) => (
                      <tr key={item.id || i}>
                        <td>{item && item.patientName}</td>

                        <td className="cmn_Cap">
                          {item && item.doctorName}
                        </td>

                        <td>
                          {item && item.prscrptnTag
                            ? item.prscrptnTag
                            : <span style={{ fontStyle: 'italic' }}>
                              -No notes provided -
                            </span>}
                        </td>

                        <td className="centerAlign">
                          {item && item.prcptImg
                            ? <ModalImage
                              small={`${appConfig.ip}/attachments/preview/${encodeURIComponent(item.prcptImg)}`}
                              large={`${appConfig.ip}/attachments/preview/${encodeURIComponent(item.prcptImg)}`}
                              hideDownload
                              hideZoom
                              className="imageModalClass"
                            />
                            : 'Preview not available'}
                        </td>

                        <td>
                          {item?.prscrptnDate &&
                            dateFormat(item.prscrptnDate, 'mediumDate')}
                        </td>

                        <td>
                          {item?.status === 'active' ? 'Active' : 'Inactive'}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              {itemPageCount > 1
                ? <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={itempage}
                    previousLabel={'Prev'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={itemPageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.itemsPageClick}
                    containerClassName={'pagination flex-wrap'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                </div>
                : null}
              {(this.props.patientsprscrptnls === undefined ||
                (this.props.patientsprscrptnls &&
                  this.props.patientsprscrptnls.length === 0)) &&
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require('../../../assets/img/nodata4.png')}
                    />
                  </div>
                  <div className="noDataTextDiv">No Data Found</div>
                </div>}
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: '#f0f3f5' }} />
          </Modal>
        </div>
      </div>
    );
  }
}

export default PatientsViewModel;
